import MDLinks from './md-links.png';
import Reactibook from './reactibook.PNG';
import Memoire from './memoire.PNG';

export default {
    MDLinks,
    Reactibook,
    Memoire
};